"use client"

import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { Station, getDapiStationGet } from "api"
import { LayoutContext } from "contexts/LayoutProvider"
import { LocationContext } from "contexts/LocationProvider"
import { calculateDistance } from "lib/utils"
import Image from "next/image"
import Link from "next/link"
import { useContext, useEffect, useRef, useState } from "react"
import { trackMapNavigationToDest } from "reusable/ChargeGTM"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import { CloseIcon, Desktop, LocationIcon, Mobile, NewText } from "ui"
import LocationsSwiper from "./LocationsSwiper"
import { getLogoByName } from "./logo"

const StyledLocation = styled.div`

  ${(props) => props.theme.breakpoints.up("md")} {
    width: 100%;
     padding: 16px 0;
    display: flex;
    flex-direction: column;
  }
      ${(props) => props.theme.breakpoints.up("md")} {
   padding-left: 14px;
   padding-right: 14px;
   padding-bottom: 0px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
   padding-left: 24px;
   padding-right: 24px;
      padding-bottom: 0px;
  }
`
const StyledWrapperPadding = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: calc(100% - 55px);
    background: #fff;
    border-radius: 16px 16px 0px 0px;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    height: calc(100% - 75px);
  }
`
const StyledLocationBlur = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(21, 62, 105, 0.8);
    bottom: 0px;
    left: 0px;
  }
`

const StyledTitleWithLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 16px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 0 24px;
  }
`

const StyledClose = styled(IconButton)`
display: flex;
justify-content: flex-end;
  &:focus {
    background-color: transparent; /* Remove default focus background */
    outline: none; /* Optionally remove the default outline */
  }

  &:focus-visible {
    outline: none; /* Remove outline when focused with keyboard */
    border: 2px solid blue; /* Optional: add a custom border on focus */
  }
  ${(props) => props.theme.breakpoints.up("md")} {
        align-self: flex-end;
  }
`

const StyledCloseButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
`

const HoursBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const StyledStationDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
    gap: 4px;
`

const StyledYellowDetailsWrapper = styled.div`
    display: flex;
  flex-direction: column;
  gap: 4px;
`

const StyledLogo = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  ${(props) => props.theme.breakpoints.up("lg")} {
    width: 80px;
    height: 80px;
  }
`

const StyledTitleWithDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

const PropertyBox = styled.div<{ lineSolid: boolean }>`
  border-bottom: 1px ${(props) => props.lineSolid ? "solid" : "dashed"} rgba(186, 210, 212, 0.9);
  padding: 12px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 12px 24px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding: 16px 28px;
  }
  display: flex;
  gap: 12px;
  flex-direction: column;
`

const StyledProperties = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding: 0;
  margin: 0;
  column-gap: 30px;
`
const StyledProperty = styled.li`
  padding: 6px 17px 6px 0px;
  display: flex;
  align-items: center;
  gap: 4px;
`
const StyledPropertyLogo = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
  /* background: black; */
`


const HoursFlex = styled.div`
  display: flex;
  flex-direction: column;
`
// const HoursItem = styled.div`
//   display: flex;
//   gap: 32px;
// `
const LocationCont = styled.div`
  display: flex;
  justify-content: space-between;
`
const StyledTop = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledBottomDiv = styled.div`
  display: flex;
  width: 100%;
  padding-top: 16px;
  display: flex;
  justify-content: end;
`

const StyledDestination = styled.div`
  display: flex;
  align-items: center;
  svg {
    path {
      stroke: #0050c9;
    }
  }
  a {
    color: #0050c9;
    text-decoration: none;
  }
`
const StyledPhone = styled(Link)`
  color: #0050c9;
  text-decoration: underline;
  font-size: 14px;
`

const StyledSubHeadling = styled(NewText)`
 padding-bottom: 4px;
`
const StyledLocationSwiperWrapper = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    background-color: #FCFDFD;
    padding-left: 15px;
    padding-bottom: 15px;
    width: 100%;
  }
`

// const array = [
//   { title: "תדלוק בשירות מלא", Icon: LocatorGas },
//   { title: "כספומט", Icon: LocatorCash },
//   { title: "פז Wash", Icon: LocatorWashing },
//   { title: "24/7", Icon: Locator247 },
//   { title: "פז Charge", Icon: LocatorCharge },
//   { title: "קפה לדרך", Icon: LocatorCoffee },
//   { title: "אוריאה", Icon: LocatorEnergy },
//   { title: "תרופות ללא מרשם", Icon: LocatorMedicine },
// ]
type Props = {
  userLoc?: {
    lat: number
    lon: number
  } | null
  locations?: Station[]
  handleClose?: () => void
}

// eslint-disable-next-line complexity
const SelectedDetails = ({ userLoc, handleClose, locations }: Props) => {
  const { selectedLocation, setSelectedLocation } = useContext(LocationContext)
  const { isApiReady } = useContext(LayoutContext)
  const [stationData, setStationData] = useState(null) as any
  const controlsRef = useRef<HTMLDivElement>(null);
  const firstElementRef = useRef<HTMLButtonElement>(null)


  useEffect(() => {
    if (!isApiReady) {
      return
    }
    if (selectedLocation) {
      const getHours = async () => {
        const { data } = await getDapiStationGet(
          selectedLocation.id,
          selectedLocation.geoLocation.latitude,
          selectedLocation.geoLocation.longitude,
          "",
          "",
        )
        if (data.Body.body) {
          setStationData(data.Body.body)
        } else {
          setStationData(null)
        }
      }
      getHours()
    }
  }, [selectedLocation, isApiReady])

  if (!selectedLocation) {
    return
  }
  return (
    <StyledLocationBlur
      role="tabpanel"
      aria-labelledby={`location_item_${selectedLocation.id}`}
      ref={controlsRef}
    >
      <StyledWrapperPadding>
        <StyledLocation>
          <Desktop>
            <StyledCloseButtonWrapper>
              <StyledClose
                id={`selectedDetail_${selectedLocation.id}`}
                ref={firstElementRef}
                size="small"
                aria-label="סגירה"
                onClick={() => {
                  setSelectedLocation(null)
                }}
                onKeyDown={(e) => {
                  if (e.key === "Tab" && e.shiftKey) {
                    setTimeout(() => {
                      const itemList = document?.getElementById(`location_item_${selectedLocation.id.toString()}`);
                      if (itemList) {
                        itemList.focus();
                      }
                    }, 100)
                  }
                }}
              >
                <CloseIcon />
              </StyledClose>
            </StyledCloseButtonWrapper>
          </Desktop>
          <StyledTop>
            <StyledTitleWithLogo>
              {selectedLocation && (
                <StyledLogo>
                  <Image
                    fill
                    alt="פז"
                    src={getLogoByName(selectedLocation.name, selectedLocation.metaData)}
                  />
                </StyledLogo>
              )}
              {selectedLocation && (
                <StyledTitleWithDescription>
                  <NewText
                    component="h3"
                    largeDesktopFontSize={24}
                    largeDesktopLineHeight="33.6px"
                    mobileFontSize={24}
                    mobileLineHeight={"33.6px"}
                    desktopFontSize={16}
                    desktopLineHeight={"22.4px"}
                    desktopFontWeight="500"
                  >
                    {selectedLocation.name}
                  </NewText>
                  <LocationCont>
                    <NewText
                      component="p"
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      desktopFontWeight="400"
                    >
                      {selectedLocation.address}
                    </NewText>
                    {userLoc ? (
                      <NewText
                        component="p"
                        largeDesktopFontSize={16}
                        largeDesktopLineHeight="24px"
                        mobileFontSize={16}
                        mobileLineHeight="24px"
                        desktopFontSize={12}
                        desktopLineHeight={"18px"}
                        desktopFontWeight="400"
                      >
                        {calculateDistance(
                          selectedLocation.geoLocation.latitude,
                          selectedLocation.geoLocation.longitude,
                          userLoc.lat,
                          userLoc.lon,
                        )}{" "}
                        ק״מ
                      </NewText>
                    ) : null}
                  </LocationCont>
                </StyledTitleWithDescription>
              )}
            </StyledTitleWithLogo>

            <Mobile>
              <StyledClose
                size="small"
                aria-label="סגירה"
                onClick={() => {
                  setSelectedLocation(null)
                  if (handleClose) {
                    handleClose()
                  }
                }}
              >
                <CloseIcon />
              </StyledClose>
            </Mobile>
          </StyledTop>
          <PropertyBox
            lineSolid={false}>
            <Mobile>
              <NewText
                mobileFontSize={16}
                desktopFontSize={16}
                component="h3"
                color={"#0050C9"}
                desktopFontWeight={500}
              >
                שירותים
              </NewText>
            </Mobile>
            <StyledProperties>
              {selectedLocation &&
                selectedLocation?.metaData.map((el) => {
                  return (
                    <StyledProperty key={el?.name}>
                      <StyledPropertyLogo>
                        {el?.image && <Image src={el?.image || ""} fill alt='' />}
                      </StyledPropertyLogo>
                      <NewText
                        component="p"
                        largeDesktopFontSize={14}
                        largeDesktopLineHeight={"20px"}
                        mobileFontSize={14}
                        mobileLineHeight={"20px"}
                        desktopFontSize={12}
                        desktopLineHeight={"18px"}
                        desktopFontWeight={500}
                        color="rgba(92, 100, 116, 1)"
                      >
                        {el?.name}{" "}
                      </NewText>
                    </StyledProperty>
                  )
                })}
            </StyledProperties>
          </PropertyBox>
          {stationData && (
            <PropertyBox
              lineSolid={true}>
              <Desktop>
                <NewText
                  largeDesktopFontSize={20}
                  largeDesktopLineHeight="28px"
                  mobileFontSize={20}
                  mobileLineHeight="28px"
                  desktopFontSize={14}
                  desktopLineHeight={"20px"}
                  component={"h3"}
                  color="black"
                  desktopFontWeight={500}
                >
                  שעות פעילות
                </NewText>
              </Desktop>
              <Mobile>
                <NewText
                  mobileFontSize={16}
                  desktopFontSize={16}
                  component="h3"
                  color={"#0050C9"}
                  desktopFontWeight={500}
                >
                  שעות פעילות
                </NewText>
              </Mobile>
              <HoursBox>

                <StyledStationDetailsWrapper>

                  <StyledSubHeadling
                    largeDesktopFontSize={16}
                    largeDesktopLineHeight="24px"
                    mobileFontSize={16}
                    mobileLineHeight="24px"
                    desktopFontSize={12}
                    desktopLineHeight={"18px"}
                    component={"h4"}
                    color="black"
                    desktopFontWeight={500}
                  >
                    תחנה
                  </StyledSubHeadling>
                  {stationData?.is24Hours && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      פתוח 24/7
                    </NewText>
                  )}
                  {stationData?.openHourWorking && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      א&apos;-ה&apos; {stationData?.openHourWorking}
                    </NewText>
                  )}
                  {stationData?.openHourFriday && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      ו&apos; {stationData?.openHourFriday}
                    </NewText>
                  )}

                  {stationData?.openHourSaturday && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      שבת {stationData?.openHourSaturday}
                    </NewText>
                  )}
                </StyledStationDetailsWrapper>
                <StyledYellowDetailsWrapper>

                  {(stationData?.openHourWorkingYellow ||
                    stationData?.openHourFridayYellow ||
                    stationData?.openHourSaturdayYellow ||
                    stationData?.is24Hours) && (
                      <StyledSubHeadling
                        largeDesktopFontSize={16}
                        largeDesktopLineHeight="24px"
                        mobileFontSize={16}
                        mobileLineHeight="24px"
                        desktopFontSize={12}
                        desktopLineHeight={"18px"}
                        component={"h4"}
                        color="black"
                        desktopFontWeight={500}
                        style={{ paddingBottom: 4 }}
                      >
                        yellow
                      </StyledSubHeadling>
                    )}
                  {stationData?.is24Hours && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      פתוח 24/7
                    </NewText>
                  )}
                  {stationData?.openHourWorkingYellow && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      א&apos;-ה&apos; {stationData?.openHourWorkingYellow}
                    </NewText>
                  )}

                  {stationData?.openHourFridayYellow && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      ו&apos; {stationData?.openHourFridayYellow}
                    </NewText>
                  )}

                  {stationData?.openHourSaturdayYellow && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      שבת {stationData?.openHourSaturdayYellow}
                    </NewText>
                  )}
                  {(stationData?.openHourWorkingCoffeeToGo ||
                    stationData?.openHourFridayCoffeeToGo ||
                    stationData?.openHourSaturdayCoffeeToGo) && (
                      <NewText
                        largeDesktopFontSize={16}
                        largeDesktopLineHeight="24px"
                        mobileFontSize={16}
                        mobileLineHeight="24px"
                        desktopFontSize={12}
                        desktopLineHeight={"18px"}
                        component={"h4"}
                        color="black"
                        desktopFontWeight={500}
                      >
                        קפה לדרך
                      </NewText>
                    )}
                  {stationData?.openHourWorkingCoffeeToGo && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      א&apos;-ה&apos; {stationData?.openHourWorkingCoffeeToGo}
                    </NewText>
                  )}

                  {stationData?.openHourFridayCoffeeToGo && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      ו&apos; {stationData?.openHourFridayCoffeeToGo}
                    </NewText>
                  )}

                  {stationData?.openHourSaturdayCoffeeToGo && (
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"div"}
                      color="black"
                      desktopFontWeight={400}
                    >
                      שבת {stationData?.openHourSaturdayCoffeeToGo}
                    </NewText>
                  )}
                </StyledYellowDetailsWrapper>
                <HoursFlex>
                  {/* {selectedLocation.StationOpeningHours.map((el) => (
                    <HoursItem key={el.Key}>
                    <NewText
                        desktopFontSize={14}
                        color="black"
                        component={"span"}
                      >
                        {el.Value}
                      </NewText>
                      <NewText
                        desktopFontSize={14}
                        color="black"
                        component={"span"}
                      >
                        {el.Key}
                      </NewText>
                    </HoursItem>
                  ))} */}
                </HoursFlex>
                {stationData?.phone && stationData?.type === 7 && (
                  <>
                    <NewText
                      largeDesktopFontSize={16}
                      largeDesktopLineHeight="24px"
                      mobileFontSize={16}
                      mobileLineHeight="24px"
                      desktopFontSize={12}
                      desktopLineHeight={"18px"}
                      component={"h4"}
                      color="black"
                      desktopFontWeight={500}
                    >
                      טלפון
                    </NewText>

                    <StyledPhone href={`tel:${stationData?.phone}`}>
                      {stationData?.phone}
                    </StyledPhone>
                  </>
                )}
              </HoursBox>
            </PropertyBox>
          )}
          {selectedLocation && (
            <Mobile>
              <StyledBottomDiv>
                <StyledDestination>
                  <LocationIcon />
                  <Link
                    href={`https://waze.com/ul?ll=${selectedLocation.geoLocation.latitude},${selectedLocation.geoLocation.longitude}`}
                    target="blank"
                    onClick={() => trackMapNavigationToDest(selectedLocation.name)}
                  >
                    ניווט ליעד
                  </Link>
                </StyledDestination>
              </StyledBottomDiv>
            </Mobile>)}
        </StyledLocation>
        <Desktop>
          {locations ? (
            <StyledLocationSwiperWrapper>
              <LocationsSwiper locations={locations} />
            </StyledLocationSwiperWrapper>
          ) : null}
        </Desktop>
      </StyledWrapperPadding>
    </StyledLocationBlur>
  )
}
export default SelectedDetails
